import React, { useEffect, useState } from 'react'
import moment from 'moment'
import EPCRCard from '../../../../components/Cards/EPCRCard'
import DetailsBox from '../../../../components/Cards/DetailsBox'
import S3DocumentUploadDisplay from '../../../../components/images/S3DocumentUploadDisplay'
import S3Document from '../../../../components/images/S3Document'
import PDFViewer from '../../../../components/Modals/PDFViewer'
import { Stack } from '@mui/material'

const Documents = ({ documents }) => {
  const [files, setFiles] = useState([])
  const [selectedDoc, setSelectedDoc] = useState(null)

  return (
      <DetailsBox title="Documents" >
      <Stack gap={1} direction="row" flexWrap="wrap">
        {documents.map((doc) => {
          const fileType = doc.split('.')[1]
          return (
            <S3Document
              item={doc}
              key={doc}
              onClick={() => setSelectedDoc(doc)}
            />
          )
        })}
      </Stack>
      <PDFViewer
        open={!!selectedDoc}
        onClose={() => setSelectedDoc(null)}
        s3key={selectedDoc}
      />
      </DetailsBox>
  )
}

export default Documents
